import { CartButtonProps } from "@omni/types/components/props/cartButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { ReactNode, useState } from "react";

import { CartButtonContextProvider } from "@/components/Navigation/Buttons/CartButton/context/cartButton.context";
import { useCartItemsCount } from "@/components/Navigation/Buttons/CartButton/hooks/useCartItemsCount.hook";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import {
    useIsBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

type Props = CartButtonProps<BaseStore> & {
    children: ReactNode;
};

const _Base = ({
    // HeaderButton props
    text,
    ariaLabel,
    hiddenText,
    icon,
    link,
    invert,
    invertMobile,
    showMenuOnHover,

    // CartButton props
    redirect,

    // Local props
    children
}: Props) => {
    const { count } = useCartItemsCount();

    const [isUpdatingCart, setIsUpdatingCart] = useState({});
    const [activeId, setActiveId] = useState("");
    const dispatch = useThunkDispatch();

    const { matches: isLarge } = useIsBreakpoint("lg");

    const handleRemoveFromCart = (
        id: string,
        quantity: number,
        free: boolean
    ) => {
        setActiveId(id);
        setIsUpdatingCartForId(id, true);
        dispatch(CartModule.removeFromCart(id, quantity, free)).then(() =>
            setIsUpdatingCartForId(id, false)
        );
    };

    const setIsUpdatingCartForId = (id: string, isUpdatingCart: boolean) => {
        setIsUpdatingCart((cur: any) => ({
            ...cur.isUpdatingCart,
            [id]: isUpdatingCart
        }));
    };

    const alerts = count ? (count < 100 ? count.toString() : "+99") : undefined;

    return (
        <CartButtonContextProvider
            headerButtonProps={{
                text: text,
                hiddenText: hiddenText,
                ariaLabel: ariaLabel,
                link: link,
                icon: icon,
                invert: invert,
                invertMobile: invertMobile,
                showMenuOnHover: showMenuOnHover && isLarge,
                alerts: alerts,
                withOverlay: !isLarge,
                iconPrefix: "las tw:text-4xl!"
            }}
            redirect={redirect}
            isUpdatingCart={isUpdatingCart}
            activeId={activeId}
            onRemoveFromCart={handleRemoveFromCart}
        >
            {children}
        </CartButtonContextProvider>
    );
};

export const Base = withBreakpoints(_Base);
